module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-statistics/event-statistics.component.scss
// module id = ./src/app/routes/event/event-statistics/event-statistics.component.scss
// module chunks = 9